import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, InputLabel, Select, MenuItem, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { MerchantActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantStepFour = (props) => {

    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch } = useForm();
    const { classes } = props;

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        return value;
    }

    const handleNext = () => {
        props.handleNext();
    };

    const handleBack = () => {
        props.handleBack();
    };

    // submitボタンのアイコンとタイトルを画面に応じて変更
    var submitIcon;
    var submitTitle;
    if (props.mode == "regist") {
        // 登録時：次へ
        submitIcon = <ArrowForwardIosIcon />;
        submitTitle = <FormattedMessage id="Button.Next" />;
    }
    else {
        // 更新時：入力し内容に変更
        submitIcon = <SaveIcon />;
        submitTitle = <FormattedMessage id="Button.Update" />;
    }

    return (
        <form className={classes.form} noValidate>
           <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Controller
                        name="financialinstitution_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.financialinstitution_name}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialNameMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.financialinstitution_name && true}
                            helperText={errors.financialinstitution_name ? errors.financialinstitution_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄ic銀行</Typography>}
                            label={<FormattedMessage id={"Merchant.BankName"} />} />} />    
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="financialinstitution_cd"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.financialinstitution_cd}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 4, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialCdMinLenPattern" />}</Typography> },
                            maxLength: { value: 4, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialCdMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.financialinstitution_cd && true}
                            helperText={errors.financialinstitution_cd ? errors.financialinstitution_cd.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0001</Typography>}
                        label={<FormattedMessage id={"Merchant.BankCode"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="branch_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.branch_name}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialBranchNameMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.branch_name && true}
                            helperText={errors.branch_name ? errors.branch_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 那覇支店</Typography>}
                            label={<FormattedMessage id={"Merchant.BranchName"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="branch_no"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.branch_no}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 3, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialBranchNoMinLenPattern" />}</Typography> },
                            maxLength: { value: 3, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialBranchNoMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.branch_no && true}
                            helperText={errors.branch_no ? errors.branch_no.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 002</Typography>}
                            label={<FormattedMessage id={"Merchant.BranchNumber"} />} />} />
                </Grid>
                 <Grid item xs={6}>
                    <FormControl fullWidth variant="outlined" error={errors.account_kbn && true}>
                        <InputLabel id="bank-label-account-type"><FormattedMessage id={"Merchant.AccountType"} /></InputLabel>
                        <Controller
                            name="account_kbn"
                            control={control}
                            onChange={onChange}
                            defaultValue={editing.account_kbn}
                                rules={{
                                    //required: <FormattedMessage id={"Error.Required"} />
                                }}
                            as={<Select
                                labelId="bank-label-account-type"
                                id="account-type"
                                label={<FormattedMessage id={"Merchant.AccountType"} />}>
                                <MenuItem value={1}><FormattedMessage id={"Merchant.AccountTypeSavings"} /></MenuItem>
                                <MenuItem value={2}><FormattedMessage id={"Merchant.AccountTypeCurrent"} /></MenuItem>
                            </Select>} />
                        <FormHelperText>{errors.account_kbn ? errors.account_kbn.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="account_no"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.account_no}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialAccountNoMinLenPattern" />}</Typography> },
                            maxLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialAccountNoMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.account_no && true}
                            helperText={errors.account_no ? errors.account_no.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 1234567</Typography>}
                            label={<FormattedMessage id={"Merchant.AccountNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="account_holder"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.account_holder}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialAccountHolderMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.account_holder && true}
                            helperText={errors.account_holder ? errors.account_holder.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄太郎</Typography>}
                            label={<FormattedMessage id={"Merchant.AccountHolder"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="account_f_holder"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.account_f_holder ? editing.account_f_holder : ''}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantFinancialAccountHolderMaxLenPattern" />}</Typography> },
                            pattern: {
                                value: /^[ァ-ヶー０-９]+$/i,
                                message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography>
                            }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.account_f_holder && true}
                            helperText={errors.account_f_holder ? errors.account_f_holder.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワハナコ</Typography>}
                            label={<FormattedMessage id={"Merchant.AccountHolderFurigana"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="external_link_cd"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.external_link_cd}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 6, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantExternalLinkCdMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.external_link_cd && true}
                            helperText={errors.external_link_cd ? errors.external_link_cd.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 7985</Typography>}
                            label={<FormattedMessage id={"Merchant.ExternalLinkCd"} />} />} />
                </Grid>

                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium" color="primary"
                            onClick={handleSubmit(handleNext)}
                            endIcon={submitIcon}>
                            {submitTitle}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(MerchantStepFour);
